import { render, staticRenderFns } from "./AwlFabAddButton.vue?vue&type=template&id=47858062&"
import script from "./AwlFabAddButton.vue?vue&type=script&lang=js&"
export * from "./AwlFabAddButton.vue?vue&type=script&lang=js&"
import style0 from "./AwlFabAddButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports